import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { Typography } from '@cp/ds/src/components/typography';
import { MOBILE_BREAKPOINT_THRESHOLD, SxProps } from '@cp/ds/src/theme';
import { styled } from '@cp/ds/src/theme/styled';
import { getAssetSrc, toAsset } from '@cp/shared/image';
import { useTrackMount, withTrackClick } from 'src/shared/tracking';
import { StepFooter } from '../stepFooter';
import { registrationStartClick, registrationWelcomeShow } from '../../lib';
import { ClientRegistrationStepProps } from './model';
import one from './assets/1x3.png';
import two from './assets/2x3.png';
import three from './assets/3x3.png';
import line1 from './assets/ld-1.svg?url';
import line2 from './assets/ld-2.svg?url';
import line1Mobile from './assets/lm-1.svg?url';
import line2Mobile from './assets/lm-2.svg?url';

const TButton = withTrackClick(Button, registrationStartClick);

const StyledT = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    gap: theme.spacing(2),
    alignItems: 'center',
    flexDirection: 'row',
  },
}));

const Text = ({ number, children, sx }: { number: number; children: React.ReactNode; sx?: SxProps }) => (
  <StyledT component="li" sx={sx}>
    <Typography component="span" variant="h0">
      {number}
    </Typography>
    <Typography variant="h3">{children}</Typography>
  </StyledT>
);

const StyledBox = styled(Box)(({ theme }) => ({
  width: '350px',
  margin: '0 auto',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: [
    `url(${getAssetSrc(toAsset(one))}) 100% 0/154px no-repeat`,
    `url(${getAssetSrc(toAsset(two))}) 0 220px/154px no-repeat`,
    `url(${getAssetSrc(toAsset(three))}) 100% 400px/154px no-repeat`,
    `url(${getAssetSrc(toAsset(line1Mobile))}) 90px 125px no-repeat`,
    `url(${getAssetSrc(toAsset(line2Mobile))}) 64px 363px no-repeat`,
  ].join(', '),
  [theme.breakpoints.down(MOBILE_BREAKPOINT_THRESHOLD)]: {
    minHeight: `calc(100dvh - ${theme.spacing(2.5)})`,
  },
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '695px',
    background: [
      `url(${one}) 0 0/200px no-repeat`,
      `url(${two}) 100% 110px/200px no-repeat`,
      `url(${three}) 0 300px/200px no-repeat`,
      `url(${line1}) 187px 96px no-repeat`,
      `url(${line2}) 162px 248px no-repeat`,
    ].join(', '),
  },
}));
const StyledList = styled(Box)(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '100px',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    padding: '30px 200px 0',
  },
}));

export const StepWelcome = ({ onSubmit }: ClientRegistrationStepProps) => {
  useTrackMount(registrationWelcomeShow);
  return (
    <StyledBox>
      <StyledList component="ol" sx={{}}>
        <Text number={1} sx={{ paddingRight: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
          Заполните анкету и загрузите фото
        </Text>
        <Text number={2} sx={{ paddingLeft: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
          Откликайтесь на интересные вакансии
        </Text>
        <Text number={3} sx={{ pr: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
          Отвечайте на чаты и звонки
        </Text>
      </StyledList>
      <StepFooter sx={{ mx: { xs: 0 } }}>
        <TButton
          onClick={() => onSubmit({})}
          sx={{
            width: { xs: '100%', [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' },
            flex: { xs: '1 0 100%', [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' },
          }}
        >
          Давайте начнем!
        </TButton>
      </StepFooter>
    </StyledBox>
  );
};
